import script from "./AddVehicleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddVehicleModal.vue?vue&type=script&setup=true&lang=js"

import "./AddVehicleModal.vue?vue&type=style&index=0&id=69edccbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69edccbe"]])

export default __exports__